// Indian numbering formatter for INR
export function inr(amount, opts = {}) {
  const n = Number(amount || 0);
  const showSymbol = opts.symbol !== false;
  const compact = opts.compact === true;
  if (compact) {
    const abs = Math.abs(n);
    if (abs >= 1_00_00_000) return `${showSymbol ? "₹ " : ""}${(n / 1_00_00_000).toFixed(2)} Cr`;
    if (abs >= 1_00_000) return `${showSymbol ? "₹ " : ""}${(n / 1_00_000).toFixed(2)} L`;
    if (abs >= 1_000) return `${showSymbol ? "₹ " : ""}${(n / 1_000).toFixed(1)} K`;
  }
  const formatted = n.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
  return `${showSymbol ? "₹ " : ""}${formatted}`;
}

export function pct(n, digits = 1) {
  return `${Number(n || 0).toFixed(digits)}%`;
}

export function dateStr(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch {
    return d;
  }
}
